import {autoinject} from "aurelia-dependency-injection";
import {AppEvents} from "../../app-events";
import Marionette from "../../shared/marionette-mustache";
import { ApplicationError } from "../../authentication/exceptions";

export enum Rejections {
    IP_SIGNIN_FAIL,
    IP_RECOGNITION_FAIL,
    URL_SIGNIN_FAIL
}
@autoinject
export class ErrorMessage extends Marionette.ItemView<Backbone.Model> {

    public visible = false;
    private clearTimeout;

    constructor(private appEvents: Backbone.Events) {
        super();
        this.setupEvents();
    }

    public handleError(err: ApplicationError) {
        console.log(err);
        this.appEvents.trigger(AppEvents.ErrorMessage, err.message);
        // switch (err.Type) {
        //     case Rejections.IP_SIGNIN_FAIL:
        //         Backbone.history.navigate("override", {trigger: true});
        //         this.appEvents.trigger(AppEvents.ErrorMessage, "Your organisation has IP recognition enabled, but no access to this product");
        //         break;
        //     case Rejections.URL_SIGNIN_FAIL:
        //         this.appEvents.trigger(AppEvents.ErrorMessage, err.Error.responseJSON.error_description);
        //         break;
        //     case Rejections.IP_RECOGNITION_FAIL:
        //     default:
        //         this.appEvents.trigger(AppEvents.ErrorMessage, "Couldn't connect to server");

        // }
    }

    private setupEvents() {
        this.appEvents.on(AppEvents.QuickInformationMessage, (message) => {
            this.showMessage(message, "info", 1500);
        });
        this.appEvents.on(AppEvents.InformationMessage, (message) => {
            this.showMessage(message, "info");
        });
        this.appEvents.on(AppEvents.ErrorMessage, (message) => {
            this.showMessage(message, "error");
        });
    }

    private showMessage(message: string, className: string, duration = 5000): void {
        const toast = $("<div role=\"alert\"></div>");
        toast.text(message);
        toast.addClass("toast-message");
        if (className) {
            toast.addClass(className);
        }
        this.visible = true;
        toast.appendTo("body");
        setTimeout(() => {
            toast.addClass("remove");
            setTimeout(() => {
                this.visible = false;
                toast.remove();
            }, 2000);
        }, duration);

    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/shared/views/error-message.ts